export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;
export const SECONDS_IN_DAY = SECONDS_IN_MINUTE * MINUTES_IN_HOUR * HOURS_IN_DAY;
export const APPROX_DAYS_IN_MONTH = 30;
export const DAYS_IN_WEEK = 7;
export const APPROX_DAYS_IN_YEAR = 365;
export const SECONDS_IN_HOUR = MINUTES_IN_HOUR * SECONDS_IN_MINUTE;
export const MILLISECONDS_IN_SECOND = 1000;
export const MILLISECONDS_IN_MINUTE = MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE;
export const MILLISECONDS_IN_HOUR = MILLISECONDS_IN_MINUTE * MINUTES_IN_HOUR;
export const MILLISECONDS_IN_DAY = MILLISECONDS_IN_HOUR * HOURS_IN_DAY;
export enum Months {
    January = "January",
    February = "February",
    March = "March",
    April = "April",
    May = "May",
    June = "June",
    July = "July",
    August = "August",
    September = "September",
    October = "October",
    November = "November",
    December = "December",
}
export enum Weekdays {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}
export enum MonthsPairs {
    JanuaryAndFebruary = "JanuaryAndFebruary",
    MarchAndApril = "MarchAndApril",
    MayAndJune = "MayAndJune",
    JulyAndAugust = "JulyAndAugust",
    SeptemberAndOctober = "SeptemberAndOctober",
    NovemberAndDecember = "NovemberAndDecember",
}
export const ISO_MONTHS = Object.values(Months).map((_, index) => index + 1);
export const ISO_WEEKDAYS = Object.values(Weekdays).map((_, index) => index + 1);

function formatMonthsPairs(firstMonth: number, secondMonth: number): string {
    return `${firstMonth}-${secondMonth}`;
}

function mapIsoMonthsToMonthsPairs() {
    return ISO_MONTHS.reduce<Record<string, MonthsPairs>>((result, _, index, array) => {
        if (index % 2 === 0) {
            const start = array[index];
            const end = array[index + 1];
            result[formatMonthsPairs(start, end)] = Object.values(MonthsPairs)[index / 2];
        }

        return result;
    }, {});
}

export function mapMonthsToMonthsPairs(months: number[]): MonthsPairs {
    const key = formatMonthsPairs(months[0], months[1]);

    return mapIsoMonthsToMonthsPairs()[key];
}

const START_HOUR_FIRST_CHAR = 0;
const START_HOUR_LAST_CHAR = 2;
const END_HOURS_TRIM = 5;
const SECONDS_STRING_TO_TRIM = ":00";
const HOURS_DIFFERENCE = 2;

export function mergeAndFormatTimeRanges(hours: { from: string; to: string }[]): string[] {
    if (!hours.length) {
        return [];
    }

    const mergedSelectedHours = hours.reduce<{ from: string; to: string }[]>((previousValue, currentValue) => {
        const last = previousValue[previousValue.length - 1];

        if (!last) {
            previousValue = [...previousValue, { ...currentValue }];

            return previousValue;
        }

        const gapBetweenHours =
            Number(currentValue.from.slice(START_HOUR_FIRST_CHAR, START_HOUR_LAST_CHAR)) -
            Number(last.to.slice(START_HOUR_FIRST_CHAR, START_HOUR_LAST_CHAR));
        const areHoursConnected = gapBetweenHours <= HOURS_DIFFERENCE;

        if (areHoursConnected) {
            last.to = currentValue.to;
        } else {
            previousValue = [...previousValue, { ...currentValue }];
        }

        return previousValue;
    }, []);

    return mergedSelectedHours.map(({ from, to }) => {
        const formattedFrom = from.endsWith(SECONDS_STRING_TO_TRIM) ? from.slice(START_HOUR_FIRST_CHAR, END_HOURS_TRIM) : from;
        const formattedTo = to.endsWith(SECONDS_STRING_TO_TRIM) ? to.slice(START_HOUR_FIRST_CHAR, END_HOURS_TRIM) : to;

        return `${formattedFrom} - ${formattedTo}`;
    });
}
